import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2, Server, Mail, Scale } from "lucide-react";

export const LegalPage = () => (
  <div className="px-4 md:px-12 py-10 max-w-3xl mx-auto pb-32" data-testid="legal-page">
    <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-white/55 hover:text-white mb-6">
      <ArrowLeft size={14} /> Retour à l'accueil
    </Link>

    <header className="mb-10">
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-xs font-bold uppercase tracking-widest mb-4">
        <Scale size={11} /> Mentions légales
      </span>
      <h1 className="font-display text-4xl md:text-6xl font-black mb-3 tracking-tight">
        Mentions légales
      </h1>
      <p className="text-white/60">Informations légales relatives au site voamada.com.</p>
    </header>

    <div className="space-y-8">

      <section>
        <h2 className="font-display text-2xl font-black mb-3 flex items-center gap-2">
          <Building2 size={20} className="text-brand-orange" /> Éditeur du site
        </h2>
        <ul className="list-disc pl-5 space-y-1.5 text-white/75">
          <li><strong>Nom commercial :</strong> Voamada</li>
          <li><strong>Domaine :</strong> voamada.com</li>
          <li><strong>Nature du projet :</strong> plateforme indépendante de promotion des talents malgaches et africains</li>
          <li><strong>Directeur de la publication :</strong> Représentant légal de Voamada</li>
          <li><strong>Contact :</strong> <a className="text-brand-orange hover:underline" href="mailto:contact@voamada.com">contact@voamada.com</a></li>
        </ul>
        <p className="text-sm text-white/55 mt-3">
          Pour toute demande relative à l'identité juridique complète de l'éditeur (raison sociale, immatriculation, TVA),
          contacte-nous à l'adresse ci-dessus — nous te répondons sous 5 jours ouvrés conformément à la LCEN.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-black mb-3 flex items-center gap-2">
          <Server size={20} className="text-brand-orange" /> Hébergeur
        </h2>
        <ul className="list-disc pl-5 space-y-1.5 text-white/75">
          <li><strong>OVHcloud SAS</strong></li>
          <li>Siège social : 2 rue Kellermann, 59100 Roubaix, France</li>
          <li>RCS Roubaix-Tourcoing : 424 761 419</li>
          <li>Téléphone : +33 (0)9 72 10 10 07</li>
          <li>Site web : <a className="text-brand-orange hover:underline" href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer">ovhcloud.com</a></li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-black mb-3">Propriété intellectuelle</h2>
        <p className="text-white/75 leading-relaxed">
          La marque <strong>Voamada</strong>, le logo, la charte graphique, le code source et l'ensemble des éléments
          de la plateforme (textes, images, vidéos, sons, design, structure) sont protégés par le Code de la propriété
          intellectuelle. Toute reproduction, représentation, modification ou exploitation, totale ou partielle,
          sans autorisation écrite préalable, est strictement interdite et constituerait une contrefaçon
          (articles L.335-2 et L.335-3 du Code de la propriété intellectuelle).
        </p>
        <p className="text-white/75 leading-relaxed mt-3">
          Les contenus publiés par les utilisateurs (musique, vidéos, photos) restent la propriété de leurs auteurs.
          Voir <Link to="/cgu#contenus" className="text-brand-orange hover:underline">CGU §3</Link> pour le détail
          des licences accordées à Voamada.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-black mb-3">Liens hypertextes</h2>
        <p className="text-white/75 leading-relaxed">
          Le site voamada.com peut contenir des liens vers des sites tiers (YouTube, TikTok, Instagram, partenaires).
          Voamada n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu,
          leurs pratiques en matière de confidentialité, ou tout dommage résultant de leur consultation.
        </p>
        <p className="text-white/75 leading-relaxed mt-3">
          Tu peux établir un lien vers voamada.com sans demande préalable, à condition de ne pas porter atteinte
          à l'image de la plateforme et de ne pas créer de confusion sur la nature de la relation entre ton site et Voamada.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-black mb-3">Crédits</h2>
        <ul className="list-disc pl-5 space-y-1.5 text-white/75">
          <li>Cartographie : © OpenStreetMap contributors · Esri World Imagery</li>
          <li>Icônes : <a className="text-brand-orange hover:underline" href="https://lucide.dev" target="_blank" rel="noopener noreferrer">Lucide</a> (licence ISC)</li>
          <li>Polices : Google Fonts (Inter)</li>
          <li>Stack technique : React, TailwindCSS, PHP 8, MySQL, OVH</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-black mb-3 flex items-center gap-2">
          <Mail size={20} className="text-brand-orange" /> Contact
        </h2>
        <ul className="list-disc pl-5 space-y-1 text-white/75">
          <li>Général : <a className="text-brand-orange hover:underline" href="mailto:contact@voamada.com">contact@voamada.com</a></li>
          <li>Confidentialité / DPO : <a className="text-brand-orange hover:underline" href="mailto:privacy@voamada.com">privacy@voamada.com</a></li>
          <li>Signalement abus : <a className="text-brand-orange hover:underline" href="mailto:abuse@voamada.com">abuse@voamada.com</a></li>
          <li>Annonceurs : <Link to="/annoncer" className="text-brand-orange hover:underline">/annoncer</Link></li>
        </ul>
      </section>

      <p className="text-sm text-white/55 pt-6 border-t border-white/5">
        Voir aussi : <Link to="/cgu" className="text-brand-orange hover:underline">CGU</Link> ·
        <Link to="/confidentialite" className="text-brand-orange hover:underline ml-1">Politique de confidentialité</Link> ·
        <Link to="/cookies" className="text-brand-orange hover:underline ml-1">Cookies</Link>
      </p>
    </div>
  </div>
);

export default LegalPage;
